import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IRole } from "../../features/Configurations/RoleManagement/interface";

interface UpdateRolePayload extends Record<string, unknown> {
  name: string;
  description: string;
  permission_data: {
    modules: Array<{
      module: string;
      permissions: Array<{
        id: number;
        name: string;
        action: string;
        codename: string;
        description: string;
      }>;
    }>;
    account?: Array<{
      id: number;
      name: string;
      email: string;
      codename: string;
    }>;
    integration_pair?: Array<{
      name: string;
      codename: string;
      tracking_id: string;
    }>;
    application: Array<{
      id: string;
      codename: string;
      name: string;
      platform?: string;
      logo?: string;
      store_id?: string;
      slug?: string;
      user_id?: string;
    }>;
  };
}

export function useUpdateRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      roleId,
      data,
    }: {
      roleId: string | number;
      data: UpdateRolePayload;
    }) => {
      const url = `${API_CONFIG.path.roles}/${roleId}`;
      return httpService.put<IRole>(url, data);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["roles"] });
      queryClient.invalidateQueries({ queryKey: ["role", variables.roleId] });
    },
  });
}
